// extracted by mini-css-extract-plugin
module.exports = {"Form":"ManualSearchForm_Form__20mqN","Sidebar":"ManualSearchForm_Sidebar__2pcFq","Input":"ManualSearchForm_Input__2IuWY","Page":"ManualSearchForm_Page__qIbjD"};